import {ENDPOINTS} from '@/config/constants'
import {pathBuilder} from '@/helpers/pathBuilder'
import {
  GetEmailTemplateByIdRequest,
  GetEmailTemplateByIdRequestSchema,
  GetEmailTemplateByIdResponse,
  GetEmailTemplateByIdResponseSchema,
  GetEmailTemplatesRequest,
  GetEmailTemplatesRequestSchema,
  GetEmailTemplatesResponse,
  GetEmailTemplatesResponseSchema,
  UpdateEmailTemplateStatusRequest,
  UpdateEmailTemplateStatusRequestSchema,
  UpdateEmailTemplateStatusResponse,
  UpdateEmailTemplateStatusResponseSchema,
} from '@/types/EmailTemplate'
import {
  CreateWhatsAppTemplateRequest,
  CreateWhatsAppTemplateRequestSchema,
  CreateWhatsAppTemplateResponse,
  CreateWhatsAppTemplateResponseSchema,
  GetWhatsAppTemplateByIdRequest,
  GetWhatsAppTemplateByIdRequestSchema,
  GetWhatsAppTemplateByIdResponse,
  GetWhatsAppTemplateByIdResponseSchema,
  GetWhatsAppTemplatesRequest,
  GetWhatsAppTemplatesRequestSchema,
  GetWhatsAppTemplatesResponse,
  GetWhatsAppTemplatesResponseSchema,
  UpdateWhatsAppTemplateStatusRequest,
  UpdateWhatsAppTemplateStatusRequestSchema,
  UpdateWhatsAppTemplateStatusResponse,
  UpdateWhatsAppTemplateStatusResponseSchema,
} from '@/types/WhatsappTemplate'
import api, {HTTPMethod} from '../helpers/api'
import {
  CreateMessageTemplateRequest,
  CreateMessageTemplateRequestSchema,
  CreateMessageTemplateResponse,
  CreateMessageTemplateResponseSchema,
} from '@/types/MessageTemplate'

export async function createMessageTemplateService(params: CreateMessageTemplateRequest) {
  return api<CreateMessageTemplateRequest, CreateMessageTemplateResponse>({
    method: HTTPMethod.POST,
    path: ENDPOINTS.CREATE_MESSAGE_TEMPLATE,
    requestSchema: CreateMessageTemplateRequestSchema,
    responseSchema: CreateMessageTemplateResponseSchema,
  })(params)
}

export async function updateMessageTemplateService(id: string, params: CreateMessageTemplateRequest) {
  return api<CreateMessageTemplateRequest, CreateMessageTemplateResponse>({
    method: HTTPMethod.PUT,
    path: pathBuilder(ENDPOINTS.MESSAGE_TEMPLATE_BY_ID).withId(id).build(),
    requestSchema: CreateMessageTemplateRequestSchema,
    responseSchema: CreateMessageTemplateResponseSchema,
  })(params)
}

export async function getWhatsAppTemplatesService(params: GetWhatsAppTemplatesRequest, signal?: AbortSignal) {
  return api<GetWhatsAppTemplatesRequest, GetWhatsAppTemplatesResponse>({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_WHATSAPP_TEMPLATES,
    requestSchema: GetWhatsAppTemplatesRequestSchema,
    responseSchema: GetWhatsAppTemplatesResponseSchema,
    signal,
  })(params)
}

export async function createWhatsAppTemplateService(params: CreateWhatsAppTemplateRequest) {
  return api<CreateWhatsAppTemplateRequest, CreateWhatsAppTemplateResponse>({
    method: HTTPMethod.POST,
    path: ENDPOINTS.CREATE_WHATSAPP_TEMPLATE,
    requestSchema: CreateWhatsAppTemplateRequestSchema,
    responseSchema: CreateWhatsAppTemplateResponseSchema,
  })(params)
}

export async function updateWhatsAppTemplateService(id: string, params: CreateWhatsAppTemplateRequest) {
  return api<CreateWhatsAppTemplateRequest, CreateWhatsAppTemplateResponse>({
    method: HTTPMethod.PUT,
    path: pathBuilder(ENDPOINTS.UPDATE_WHATSAPP_TEMPLATE).withId(id).build(),
    requestSchema: CreateWhatsAppTemplateRequestSchema,
    responseSchema: CreateWhatsAppTemplateResponseSchema,
  })(params)
}

export async function getWhatsAppTemplateByIdService(id: string, signal?: AbortSignal) {
  return api<GetWhatsAppTemplateByIdRequest, GetWhatsAppTemplateByIdResponse>({
    method: HTTPMethod.GET,
    path: pathBuilder(ENDPOINTS.GET_WHATSAPP_TEMPLATE).withId(id).build(),
    requestSchema: GetWhatsAppTemplateByIdRequestSchema,
    responseSchema: GetWhatsAppTemplateByIdResponseSchema,
    signal,
  })()
}

export async function updateWhatsAppTeplateStatusService(id: string, params: UpdateWhatsAppTemplateStatusRequest) {
  return api<UpdateWhatsAppTemplateStatusRequest, UpdateWhatsAppTemplateStatusResponse>({
    method: HTTPMethod.PATCH,
    path: pathBuilder(ENDPOINTS.UPDATE_WHATSAPP_TEMPLATE_STATUS).withId(id).build(),
    requestSchema: UpdateWhatsAppTemplateStatusRequestSchema,
    responseSchema: UpdateWhatsAppTemplateStatusResponseSchema,
  })(params)
}

export async function getEmailTemplatesService(
  params: Omit<GetEmailTemplatesRequest, 'channel'>,
  signal?: AbortSignal
) {
  return api<GetEmailTemplatesRequest, GetEmailTemplatesResponse>({
    method: HTTPMethod.GET,
    path: ENDPOINTS.LOAD_MESSAGE_TEMPLATES,
    requestSchema: GetEmailTemplatesRequestSchema,
    responseSchema: GetEmailTemplatesResponseSchema,
    signal,
  })({...params, channel: 'EMAIL'})
}

export async function getEmailTemplateByIdService(id: string, signal?: AbortSignal) {
  return api<GetEmailTemplateByIdRequest, GetEmailTemplateByIdResponse>({
    method: HTTPMethod.GET,
    path: pathBuilder(ENDPOINTS.MESSAGE_TEMPLATE_BY_ID).withId(id).build(),
    requestSchema: GetEmailTemplateByIdRequestSchema,
    responseSchema: GetEmailTemplateByIdResponseSchema,
    signal,
  })()
}

export async function updateEmailTemplateStatusService(id: string, params: UpdateEmailTemplateStatusRequest) {
  return api<UpdateEmailTemplateStatusRequest, UpdateEmailTemplateStatusResponse>({
    method: HTTPMethod.PATCH,
    path: pathBuilder(ENDPOINTS.MESSAGE_TEMPLATE_BY_ID).withId(id).build(),
    requestSchema: UpdateEmailTemplateStatusRequestSchema,
    responseSchema: UpdateEmailTemplateStatusResponseSchema,
  })(params)
}
